module.exports = __webpack_public_path__ + "static/media/buddha-group.57e45274.jpg";